import React, { useMemo } from 'react';

import { Body } from '@swyftx/aviary/atoms/Typography';
import { Tick } from '@swyftx/aviary/icons/outlined';
import { types } from '@swyftx/marketing-utils';

import { Big } from '@shared/safe-big';

import { useRewardQualificationProgress } from '@routes/Rewards/hooks';

import { Circle } from 'lucide-react';

type Props = {
  redemptionRequirement: types.UserAssetRedemptionRequirement | types.UserAssetRewardQualification;
  linkedRequirement?: types.UserAssetRedemptionRequirement;
};

const calculateProgress = (
  requirement: types.UserAssetRedemptionRequirement | types.UserAssetRewardQualification,
): number => {
  const progressValue = 'progress' in requirement ? requirement.progress ?? 0 : 0;
  return Big(progressValue)
    .div(requirement.thresholdAmount || 1)
    .toNumber();
};

const RewardCardProgress: React.FC<Props> = ({ redemptionRequirement, linkedRequirement }) => {
  const { label } = useRewardQualificationProgress(redemptionRequirement);

  const progress = useMemo(() => calculateProgress(redemptionRequirement), [redemptionRequirement]);

  const showCompletedIcon = useMemo(() => {
    if (!linkedRequirement) {
      return progress === 1;
    }

    const linkedProgress = calculateProgress(linkedRequirement);
    return progress === 1 && linkedProgress === 1;
  }, [linkedRequirement, progress]);

  return (
    <div className='flex content-start items-center gap-12 p-8'>
      {/* // TODO color this <Circle/> --color-lightgrey-300 but that color isnt in the token list, #d8dade */}
      {showCompletedIcon ? <Tick /> : <Circle className='stroke-color-background-surface-disabled' />}
      <Body size='small'>{label}</Body>
    </div>
  );
};

export { RewardCardProgress };
